import { isNativeApp, getPlatform } from './platform';
import { userAPI } from './api';

// Registers the device for native push notifications (no-op on web/PWA).
// Requires FCM (Android) / APNs (iOS) configured in the native project.
export const initPushNotifications = async () => {
  if (!isNativeApp()) return;
  if (!localStorage.getItem('token')) return; // only for signed-in users

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');

    let permission = await PushNotifications.checkPermissions();
    if (permission.receive === 'prompt') {
      permission = await PushNotifications.requestPermissions();
    }
    if (permission.receive !== 'granted') return;

    await PushNotifications.register();

    PushNotifications.addListener('registration', async (token) => {
      try {
        await userAPI.registerPushToken(token.value, getPlatform());
      } catch (e) {
        console.warn('Failed to send push token to server', e);
      }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.warn('Push registration error', err);
    });
  } catch (e) {
    console.warn('Push notifications unavailable', e);
  }
};
